export default {
  render: function render(h) {
    var child = [];
    child.push(this.buildCaller(h));
    if (this.isSearch) {
      child.push(this.buildHeader(h));
      child.push(this.buildSearch(h));
    }
    child.push(this.buildMessage(h));
    child.push(this.buildContent(h));
    child.push(this.buildPagination(h));

    return h('v-dropdown', {
      props: {
        'full-width': true,
        width: this.width,
        disabled: this.disabled,
        border: false,
        align: this.rtl ? 'right' : 'left',
        dropWidth: this.dropWidth,
        dropClass: this.dropClass
      },
      class: 'v-selectpage',
      attrs: {
        dicName: this.dicName
      },
      on: {
        show: this.showChange
      },
      ref: 'drop'
    }, child);
  },

  methods: {
    /**
     * 选择面板
     */
    buildCaller: function buildCaller(h) {
      var input = [];
      var inputAttrs = {
        props: {
          disabled: this.disabled,
          placeholder: this.placeholderString,
          picked: this.picked,
          clear: this.clear
        },
        on: {
          remove: this.remove
        }
      };
      input.push(h(this.multiple ? 'sp-tag' : 'sp-select', inputAttrs));
      input.push(h('div', {
        class: {
          'sp-button': true,
          open: this.show
        }
      }, [h('span', { class: 'sp-caret' })]));
      return h('template', { slot: 'caller' }, [h('div', { class: this.inputClasses }, input)]);
    },

    /**
     * header bar
     */
    buildHeader: function buildHeader(h) {
      var _this = this;

      var header = [];
      header.push(h('h3', { domProps: { innerHTML: this.headerTitle } }));
      var genBtn = function genBtn(title, btnClass, iconClass, event) {
        return h('button', {
          attrs: {
            type: 'button',
            title: title
          },
          class: btnClass,
          on: { click: function click() {
              event();
            } }
        }, [h('i', { class: 'sp-iconfont ' + iconClass })]);
      };

      if (this.multiple) {
        header.push(genBtn(this.i18n.select_all, 'sp-select-all-btn', 'sp-icon-select-all', function () {
          _this.pickPage();
        }));
        header.push(genBtn(this.i18n.unselect_all, 'sp-remove-all-btn', 'sp-icon-unselect-all', function () {
          _this.pickPage(false);
        }));
      }
      if (this.clear) {
        header.push(genBtn(this.i18n.clear_all, 'sp-clear-all-btn', 'sp-icon-clear', this.remove));
      }

      header.push(genBtn(this.i18n.close_btn, 'sp-close-btn', 'sp-icon-close', this.close));

      return h('div', { class: 'sp-header' }, header);
    },

    /**
     * 搜索条
     */
    buildSearch: function buildSearch(h) {
      var _this2 = this;

      return h('div', { class: 'sp-search' }, [h('input', {
        attrs: {
          type: 'text',
          autocomplete: 'off',
          placeholder: '请输出查询内容',
          style: 'border: 1px solid #bdcaf1',
          value: this.search.trim()
        },
        class: {
          'sp-search-input': true,
          'sp-search-input--rtl': this.rtl
        },
        on: {
          keyup: function keyup(e) {
            return _this2.processKey(e);
          },
          keydown: function keydown(e) {
            e.stopPropagation();
            _this2.processControl(e);
          },
          input: function input(e) {
            _this2.search = e.target.value;
            if (e.target.value === '') {
              // 无搜索数据时去找出选择项
              _this2.findSelectionPage();
            }
          }
        },
        ref: 'search'
      })]);
    },
    buildMessage: function buildMessage(h) {
      var _this3 = this;

      var child = [];
      if (this.message) {
        child.push(h('div', { class: 'sp-message' }, [h('i', { class: 'sp-iconfont sp-icon-warning' }), h('span', { domProps: { innerHTML: this.message } })]));
      }

      return h('transition', {
        props: {
          name: 'sp-message-slide',
          appear: true
        },
        on: {
          enter: function enter() {
            return _this3.adjust();
          },
          'after-leave': function afterLeave() {
            return _this3.adjust();
          }
        }
      }, child);
    },
    buildContent: function buildContent(h) {
      var _this4 = this;

      var child = [];
      if (this.list.length) {
        var contentAttrs = {
          props: {
            list: this.list,
            picked: this.picked,
            dropHeight: this.dropHeight
          },
          model: {
            value: this.highlight,
            callback: function callback(value) {
              _this4.highlight = value;
            }
          },
          on: {
            select: function select(row) {
              return _this4.selectItem(row);
            }
          }
        };
        if (this.tbColumns && this.tbColumns.length) {
          contentAttrs.props['tb-columns'] = this.tbColumns;
          child.push(h('sp-table', contentAttrs));
        } else {
          child.push(h('sp-list', contentAttrs));
        }
      } else {
        child.push(h('div', { class: 'sp-result-message' }, this.i18n.not_found));
      }
      return h('div', { class: 'sp-result-area' }, child);
    },

    /**
     * 分页工具
     */
    buildPagination: function buildPagination(h) {
      var _this5 = this;

      if (this.pagination) {
        return h('sp-page', {
          props: {
            'total-row': this.totalRows,
            'page-size': this.pageSize
          },
          model: {
            value: this.pageNumber,
            callback: function callback(value) {
              _this5.pageNumber = value;
            }
          },
          ref: 'page'
        });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/mixins/render.js
// module id = 20
// module chunks = 0